import { render } from "./AddBalanceComponent.vue?vue&type=template&id=b435cffa"
import script from "./AddBalanceComponent.vue?vue&type=script&lang=js"
export * from "./AddBalanceComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__